const STORAGE_KEY = 'viewly_recently_viewed';
const MAX_ITEMS = 12;

let memoryCache = null;

const safeWrite = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // Quota exceeded or storage disabled — fall back to memory cache only
  }
};

const safeRead = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const addToRecentlyViewed = (item) => {
  if (!item || !item.id || !item.type) return [];

  const existing = getRecentlyViewed();
  const filtered = existing.filter(
    (i) => !(i.id === item.id && i.type === item.type)
  );

  const updated = [
    {
      id: item.id,
      title: item.title,
      poster_path: item.poster_path,
      type: item.type,
    },
    ...filtered,
  ].slice(0, MAX_ITEMS);

  memoryCache = updated;
  safeWrite(updated);
  return updated;
};

export const getRecentlyViewed = () => {
  if (memoryCache !== null) return memoryCache;
  memoryCache = safeRead();
  return memoryCache;
};

export const clearRecentlyViewed = () => {
  memoryCache = [];
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};

export const removeFromRecentlyViewed = (id, type) => {
  const filtered = getRecentlyViewed().filter(
    (item) => !(item.id === id && item.type === type)
  );
  memoryCache = filtered;
  safeWrite(filtered);
  return filtered;
};
